// Paleta WTF en estructura Monks: crema, negro/navy y volt como único pop.
export const THEMES = {
  bone: { bg: "#F4F1E8", fg: "#0A0A0C" },   // claro, aire
  night: { bg: "#0A0A0C", fg: "#F4F1E8" },  // oscuro
  ink: { bg: "#14141A", fg: "#F4F1E8" },    // oscuro alternativo
  volt: { bg: "#FF3B30", fg: "#F4F1E8" },   // bloque-clímax: naranja del deck, texto crema
};
